module.exports = __webpack_public_path__ + "media/images/home-page/3-4@2x-8749e7e283fd07d84a99f5f3251ff26b.png";